module.exports = __webpack_public_path__ + "static/img/easnillien.972e72c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/scoiatael/easnillien.png
// module id = kJUB
// module chunks = 0